import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-fehlerbeschreibung-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeFehlerbeschreibungHinzufuegenEffects {

    AufgabeFehlerbeschreibungHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN),
        mergeMap((x: ac.PostAufgabeFehlerbeschreibungHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeFehlerbeschreibungHinzufuegen(x.aufgabeFehlerbeschreibungRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeFehlerbeschreibungHinzufuegenErfolgreichAction(result, x.aufgabeFehlerbeschreibungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeFehlerbeschreibungHinzufuegenFehlerAction(error, x.aufgabeFehlerbeschreibungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
